/* eslint-disable */
export default {
  inAMeeting: '모임 중',
  onMyWay: '가는 중',
  callMeBackIn: '다음 이후 다시 전화해 주세요...',
  willCallYouBackIn: '다음 이후 다시 전화하겠습니다...',
  hour: '시간',
  min: '분',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
